import React, { useEffect, useState } from 'react';
import { api } from '../api.js';

export default function CommandBar({ project }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    function onOpen() { setOpen(true); setQ(''); setResults([]); }
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); onOpen(); }
      if (e.key === 'Escape') setOpen(false);
    }
    window.addEventListener('openCmdK', onOpen);
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('openCmdK', onOpen); window.removeEventListener('keydown', onKey); };
  }, []);

  useEffect(() => {
    if (!open || !q) { setResults([]); return; }
    const url = project ? `/api/projects/${project._id}/search` : `/api/search`;
    let cancelled = false;
    api(`${url}?q=${encodeURIComponent(q)}`).then(r => !cancelled && setResults(r)).catch(() => {});
    return () => { cancelled = true; };
  }, [open, q, project]);

  if (!open) return null;
  return (
    <div className="cmdk-overlay" onClick={() => setOpen(false)}>
      <div className="cmdk-panel" onClick={(e) => e.stopPropagation()}>
        <input
          className="cmdk-input"
          autoFocus
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder={project ? 'Search this project — dossier, thread, decision…' : 'Search the workshop — a project to enter…'}
        />
        <ul className="cmdk-results" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {results.map((r, i) => (
            <li key={i} className="cmdk-row">
              <span className="what">{r.what}</span>
              <span className="where">{r.kind} · {r.where}</span>
            </li>
          ))}
        </ul>
        <div className="cmdk-foot">↑↓ navigate · ⏎ open · esc dismiss</div>
      </div>
    </div>
  );
}
